import React from "react"
import { graphql, Link } from "gatsby"
import TimeAgo from "timeago-react"

const PostBlogLink = ({ post, summary, date }) => {
  return (
    <div key={post.node.path} className="bloglist">
    <Link className="is-size-5" to={post.node.path}>
      {post.node.context.title}
    </Link> {date? <TimeAgo datetime={post.node.context.date} locale="en" />:<span></span>}
    {summary ? <div className="is-size-6">{post.node.context.excerpt}</div> : <div />}
    
    </div>
  )
}

const PostLinkLink = ({ post, summary, date }) => {
  return (
    <div key={post.node.path} className="bloglist">
    <span role="img" aria-label="link">&#x1F517;</span><a className="is-size-5" href={post.node.context.url}>
      {post.node.context.title}
    </a> <Link className="is-size-6" to={post.node.path}>(via)
    </Link> {date? <TimeAgo datetime={post.node.context.date} locale="en" />:<span></span>}
    {summary ? <div className="is-size-6"  dangerouslySetInnerHTML={{__html:post.node.context.excerpt}}></div> : <div></div>}
    </div>
  )
}

const GenerateBlogList = ({edges, summary, date}) => {
    const Posts = edges.map(edge => {
      if (edge.node.context.type === "Link") {
        return <PostLinkLink key={edge.node.path} post={edge} summary={summary} date={date}/>
      } else {
        return <PostBlogLink key={edge.node.path} post={edge} summary={summary} date={date}/>
      }
    });
    return Posts;
}

export default GenerateBlogList